/**
 * Coordinate formatting utilities used in the side panel and popups.
 */

/**
 * Formats a lat/lng pair for display and Google Maps linking.
 *
 * Display uses 4 decimal places with cardinal indicators (never a minus sign):
 *   "49.4170°N 4.2920°E"
 *
 * The Google Maps URL uses 5 decimal places (~1 m precision), regardless of
 * what is shown in the UI:
 *   "https://maps.google.com/?q=49.41700,4.29200"
 *
 * @param lat - latitude in decimal degrees
 * @param lon - longitude in decimal degrees
 * @returns `{ display, gmapsUrl }`
 */
export function formatCoords(
  lat: number,
  lon: number,
): { display: string; gmapsUrl: string } {
  const latCard = lat >= 0 ? 'N' : 'S';
  const lonCard = lon >= 0 ? 'E' : 'W';
  const display = `${Math.abs(lat).toFixed(4)}°${latCard} ${Math.abs(lon).toFixed(4)}°${lonCard}`;
  const gmapsUrl = `https://maps.google.com/?q=${lat.toFixed(5)},${lon.toFixed(5)}`;
  return { display, gmapsUrl };
}
